var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Rename Database ")]
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "py-1",
                          attrs: {
                            type: "warning"
                          }
                        },
                        [
                          _vm._v(
                            " It is a potentially dangerous operation to rename a MySQL database. You may want to back up this database before renaming it. "
                          )
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "mb-0"
                        },
                        [
                          _vm._v("Old name: "),
                          _c("strong", [_vm._v(_vm._s(_vm.database.db))])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:".concat(_vm.maxlength),
                            expression: "`required|max:${maxlength}`"
                          }
                        ],
                        attrs: {
                          label: "New Name",
                          name: "New Name",
                          prefix: _vm.namePrefix,
                          counter: _vm.maxlength,
                          required: "",
                          "error-messages": _vm.errors.collect("New Name")
                        },
                        model: {
                          value: _vm.name,
                          callback: function callback($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0",
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0",
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.renameDatabase
                  }
                },
                [_vm._v(" Rename ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }